export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-20.jpg'),
        title: 'AIどうがせいさく',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'AIどうがせいさく',
      description: `<p >デジタルコンテンツが爆発的に増加する現代において、AI技術は映像制作の産業構造を根本から再構築し、従来の制作プロセスにおける効率のボトルネック、高コスト、クリエイティブの限界といった課題を一つずつ解決しています。AI動画制作企業は「技術＋クリエイティブ＋サービス」という中核的競争力を活かし、様々な業界のクライアントに対し、ニーズの分析から効果実現までのフルチェーン動画ソリューションを提供。コンテンツ制作効率を300％向上させ、コストを50％以上削減する価値のブレークスルーを実現し、ブランドコミュニケーションとシーン実現の中核パートナーとなっています。</p>
<p>中小企業の「迅速な試行錯誤、低予算」ニーズに対応するため、軽量かつテンプレート化された大量生産サービスを提供し、効率的な実現を可能にします。業界特化テンプレート1,000種類以上を搭載し、店舗集客、イベント宣伝、ライブ配信ハイライトなど主要シーンをカバー。クライアントは基本素材をアップロードするだけで、AIが自動的に編集、字幕追加、BGM生成を行い、5分以内にTikTok、WeChat、Xiaohongshuなどの多プラットフォーム対応フォーマット（9:16縦画面、16:9横画面、1:1正方形）の動画を出力します。720P/1080Pの高画質出力にも対応しています。</p>`
    },
    {
      title: '私たちの強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-20.jpg')+`)"></span>
      <span class="list">
      <i></i>AI駆動のインテリジェント脚本・絵コンテ生成により、制作サイクルを大幅に短縮し、クリエイティブを迅速に実現します。<br/>
      <i></i>リアル調からアニメ調までワンクリックで切り替え可能なスタイル化された視覚効果を自動マッチングし、多様なシーン要件に対応します。<br/>
      <i></i>低コストかつ迅速な反復により、少予算でも映画級の質感を実現できます。<br/>
      <i></i>インテリジェント音声合成、字幕と映像の自動同期により、動画制作をより効率的で手間いらずにします。<br/>
      <i></i>複数バージョンの動画一括生成をサポートし、異なるプラットフォームと配信ニーズに柔軟に対応します。<br/>
      </span>`
    }
  ]
}
